/* eslint-disable max-len */
import React, { useMemo } from 'react'
import InventoryBadge from './InventoryBadge'
import useManageStock from '../hooks/useManageStock'

const QuantitiesItem = ({
  item,
  subItem,
  selectedSubItems,
  onSubItemChange,
}) => {
  const quantity = useMemo(() => {
    const selected = selectedSubItems.find(
      (i) => i.type === subItem.type && i.name === item.name
    )
    return selected ? (selected.quantity ?? selected.qty ?? 1) : 0
  }, [selectedSubItems, subItem.type, item.name])

  const { remainingStock, isSoldOut } = useManageStock(item.maxQty, item.orderCount, quantity)

  const handleDecrement = (e) => {
    e.stopPropagation()
    const nextQty = quantity <= 1 ? 0 : quantity - 1
    if (quantity <= 1) {
      onSubItemChange(subItem, { name: item.name, price: item.price, quantity: 0 })
    } else {
      onSubItemChange(subItem, { name: item.name, price: item.price, quantity: nextQty })
    }
  }

  const handleIncrement = (e) => {
    e.stopPropagation()
    if (remainingStock > 0) {
      const nextQty = quantity + 1
      onSubItemChange(subItem, { name: item.name, price: item.price, quantity: nextQty })
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        padding: '8px 10px',
        background: '#FAFAF8',
        borderRadius: '8px',
        border: '0.5px solid #f0f0f0',
      }}
    >
      <span
        style={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#1a1a18',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        }}
      >
        {item.name}
      </span>
      {!isSoldOut && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 1, minWidth: 0 }}>
            {item.price > 0 && (
              <span style={{ fontSize: '11px', color: '#009A97', flexShrink: 0 }}>
                +${Number(item.price).toFixed(2)}
              </span>
            )}
            {item.maxQty !== undefined && (
              <InventoryBadge
                count={Math.max(0, remainingStock)}
                soldOut={isSoldOut}
                className="edv2-subitem-badge"
              />
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
            <button
              type="button"
              onClick={handleDecrement}
              disabled={quantity <= 0}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                border: '0.5px solid #D3D1C7',
                background: 'white',
                cursor: 'pointer',
                fontSize: '16px',
                lineHeight: 1,
                color: '#1a1a18',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: quantity <= 0 ? 0.5 : 1,
                padding: 0,
              }}
            >
              -
            </button>
            <span
              style={{
                fontSize: '14px',
                fontWeight: 700,
                minWidth: '18px',
                textAlign: 'center',
                color: '#1a1a18',
              }}
            >
              {quantity}
            </span>
            <button
              type="button"
              onClick={handleIncrement}
              disabled={remainingStock <= 0}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                border: 'none',
                background: '#009A97',
                cursor: 'pointer',
                fontSize: '16px',
                lineHeight: 1,
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: remainingStock <= 0 ? 0.5 : 1,
                padding: 0,
              }}
            >
              +
            </button>
          </div>
        </div>
      )}
      {isSoldOut && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
          <InventoryBadge count={0} soldOut={true} className="edv2-subitem-badge" />
        </div>
      )}
    </div>
  )
}

const SubItemChooseQuantities = ({
  subItem,
  quantityEntry,
  price,
  onSubItemChange,
}) => {
  const selectedSubItems = quantityEntry?.subItems || []

  const { totalQty, totalPrice } = useMemo(() => {
    let qty = 0
    let priceSum = 0

    subItem.list?.forEach((l) => {
      const selectedSubItem = selectedSubItems.find(
        (item) => item.type === subItem.type && item.name === l.name
      )
      const quantity = selectedSubItem ? (selectedSubItem.quantity ?? selectedSubItem.qty ?? 1) : 0
      qty += quantity
      priceSum += quantity * ((price || 0) + (l.price || 0))
    })

    return { totalQty: qty, totalPrice: priceSum }
  }, [subItem.list, selectedSubItems, subItem.type, price])

  return (
    <div className="edv2-subitems__quantities-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {subItem.list?.map((l, index) => (
        <QuantitiesItem
          key={index}
          item={l}
          subItem={subItem}
          selectedSubItems={selectedSubItems}
          onSubItemChange={onSubItemChange}
        />
      ))}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '10px',
          fontSize: '12px',
          paddingBottom: '8px',
        }}
      >
        <span style={{ color: '#888780' }}>
          Total pieces: <strong style={{ color: '#1a1a18' }}>{totalQty}</strong>
        </span>
        <span style={{ color: '#009A97', fontWeight: 700 }}>${totalPrice.toFixed(2)}</span>
      </div>
    </div>
  )
}

export default SubItemChooseQuantities
